import styled from 'styled-components';

const Avatar = ({
  username,
}) => {
  const initials = () => {
    if (username) return `${username[0].toUpperCase()}${username[1].toUpperCase()}`
    return ''
  }

  return <Container>
    <Initials>
      {initials()}
    </Initials>
  </Container>
}

export default Avatar;

const Container = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #52B9D1;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Initials = styled.span`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.16px;
  color: white;
`